<div class="download-link" (click)="onClick()">Download quote here</div>
